var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24.5",
    style: {
      enableBackground: "new 0 0 24 24.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1D1D1B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000072262288290549989020000005867838989494194340_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_107-3",
    className: "st0",
    d: "M1.2,18c0.4-1,0.6-1.1,1.8-1.1h16.8c-0.1-0.2-0.2-0.3-0.4-0.5c-0.8-0.8-1.7-1.7-2.5-2.5 c-0.5-0.4-0.6-1.2-0.2-1.7c0,0,0,0,0,0l0,0l0.1-0.2c0.5-0.5,1.3-0.4,1.8,0.1l0.1,0.1c1.6,1.6,3.3,3.3,4.9,4.9 c0.5,0.4,0.6,1.2,0.2,1.7c-0.1,0.1-0.1,0.2-0.2,0.2c-1.6,1.7-3.3,3.3-5,5c-0.4,0.5-1.2,0.6-1.7,0.2l0,0l-0.1-0.1 c-0.5-0.5-0.5-1.3,0-1.7l0.1-0.1c0.9-1,1.9-1.9,3-3H19c-5.3,0-10.7,0-16,0c-0.8,0.1-1.6-0.4-1.8-1.2L1.2,18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108-3",
    className: "st0",
    d: "M4.3,7.6l2.2,2.3c0.3,0.3,0.5,0.5,0.8,0.8c0.5,0.5,0.5,1.2,0,1.7c0,0,0,0,0,0l0,0l0,0 c-0.5,0.5-1.3,0.5-1.7,0c-0.2-0.2-0.5-0.4-0.7-0.7L0.6,7.4C0,7.1-0.2,6.3,0.2,5.7c0,0,0,0,0,0c0.1-0.1,0.2-0.3,0.4-0.3l4.8-4.8 C5.8,0,6.6-0.2,7.1,0.2l0.1,0.1c0.6,0.5,0.5,1.2-0.2,1.9L4.2,5.2h17.2c0.9,0,1.4,0.5,1.4,1.3c0,0.6-0.4,1-1,1.1 c-0.3,0-0.5,0-0.8,0L4.3,7.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentActive);
export default __webpack_public_path__ + "static/media/payment-active.15c03529d2b9859fb87253e5f12c1194.svg";
export { ForwardRef as ReactComponent };